import { z } from 'zod';
/**
 * Pul — har doim TIYINDA, `bigint` sifatida. 385 000 so'm = 38_500_000n.
 *
 * JSON'da `bigint` yo'q, shuning uchun transport qatlamida u string bo'lib
 * yuradi. Klient hech qachon pul ustida arifmetika qilmaydi — faqat ko'rsatadi.
 *
 * Batafsil: `.claude/skills/avtopart-money/SKILL.md`
 */
export const MoneySchema = z
    .string()
    .regex(/^-?\d+$/, "Pul butun son bo'lishi kerak (tiyinda)")
    .describe('Pul, tiyinda, string sifatida');
/** Bir so'mdagi tiyin soni. */
export const TIYIN_PER_SUM = 100n;
/** Foiz basis point'da: 12.5% = 1250. Float foiz ishlatilmaydi. */
export const BASIS_POINTS = 10000n;
/** Transport shaklidan domen shakliga. Zod validatsiyasidan KEYIN chaqiriladi. */
export function toTiyin(value) {
    return BigInt(value);
}
/**
 * Xavfsiz parser — noto'g'ri kirishda TASHLAMAYDI, `null` qaytaradi.
 *
 * Zod `.refine` ichida `BigInt()` ni to'g'ridan-to'g'ri chaqirish XAVFLI:
 * maydon o'z schemasidan o'tmagan bo'lsa ham (masalan "1000.50") Zod
 * refinement'ni baribir ishga tushiradi ("dirty" holat), va `BigInt()`
 * tashlagan xato 500 ga aylanadi. Refinement'lar shu funksiyani ishlatadi.
 */
export function parseTiyin(value) {
    return /^-?\d+$/.test(value) ? BigInt(value) : null;
}
/** Domen shaklidan transport shakliga. */
export function fromTiyin(value) {
    return value.toString();
}
/**
 * Chegirma qo'llash. Ko'paytirish oldin, bo'lish keyin — aks holda
 * har qatorda tiyin yo'qoladi.
 */
export function applyDiscountBp(amount, discountBp) {
    if (discountBp < 0n || discountBp > BASIS_POINTS) {
        throw new RangeError(`Chegirma 0..${BASIS_POINTS.toString()} bp oralig'ida bo'lishi kerak`);
    }
    return (amount * (BASIS_POINTS - discountBp)) / BASIS_POINTS;
}
/**
 * Eng yaqin so'mga yaxlitlash (yarim yuqoriga). Yaxlitlash faqat oxirgi
 * qadamda, va faqat shu funksiya orqali qilinadi.
 */
export function roundToSum(amount) {
    const half = TIYIN_PER_SUM / 2n;
    if (amount >= 0n) {
        return ((amount + half) / TIYIN_PER_SUM) * TIYIN_PER_SUM;
    }
    return -(((-amount + half) / TIYIN_PER_SUM) * TIYIN_PER_SUM);
}
/** Qator summasi: birlik narxi × miqdor. Miqdor butun son. */
export function lineTotal(unitPrice, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) {
        throw new RangeError("Miqdor musbat butun son bo'lishi kerak");
    }
    return unitPrice * BigInt(quantity);
}
/** Yig'indi har doim qatorlardan yig'iladi, teskarisi emas. */
export function sum(amounts) {
    return amounts.reduce((acc, x) => acc + x, 0n);
}
//# sourceMappingURL=money.js.map